import React from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';

const MGOP = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='lg:px-32 lg:pb-0 mb-44 lg:mb-0 lg:py-10 p-14 lg:pt-20'
    >
    <div className='lg:flex flex-2'>
        <div className='lg:h4 h5 flex-1'>
            Mapping Geographies<br/> of Power <br/>
                      <p><hr className="border-t border-2 border-gray-800 my-6 w-1/3" /></p>

        </div>
        <div className='flex-1'>
            <p className='text-sm lg:pb-20'>Arta Shadman and Parimah Avani <br/> Site-specific ephemeral performance <br/>Presented by Bianca Bellucci during Decolonizzare i Mondi Festival,<br/> Genova – November 2024 <br/><br/>
            Conceived by artist and researcher Arta Shadman, Mapping Geographies of Power is a collaborative ephemeral performance created with Parimah Avani. The work expands their shared inquiry into decoloniality, spatial memory, and the lived aftermath of empire.
The project maps a symbolic line from the house of Cristoforo Colombo—a charged site representing the onset of colonial expansion—to the contemporary exhibition space. This act activates public space as a contested geography of history and resistance. The performance explores the complexities of decolonization by shifting focus from solely the victimhood of the colonized to the structures of power that perpetuated and normalized colonization. By tracing a line from Cristoforo Colombo's house—a symbol of colonial expansion—to the exhibition space, this performance connects the physical and historical geographies of power and resistance. The line becomes a metaphor for the boundaries drawn and erased by colonial systems, embodying both the violence of division. Chalk, a temporary and fragile material, reflects the transient yet enduring weight of colonial history. The act of tracing this line, ephemeral yet deliberate, challenges us to confront the ongoing legacies of colonization—not just as a reclamation of identity, but as an unflinching examination of the systems that shaped it. 
By situating this act within the streets of Genoa—a city marked by imperial memory—Mapping Geographies of Powerreinforces the role of performative art in unsettling dominant historical narratives and reclaiming agency within contested space.

<br/>
<br/>

</p>
        </div>
    </div>
    </motion.section>
  )
}

export default MGOP